export default {
    "Duplicate option": "オプションを複製",
    "Transition timing": "切り替えのタイミング",
    "Group duration": "グループの時間",
    "Linked State durations": "リンク先のステートの時間",
    "Applies to all options in this Group State": "このグループステートのすべてのオプションに適用",
    "Capture current appearance as a new option": "現在の表示を新しいオプションとして取得",
    "Option": "オプション",
    "Option edits": "オプションの編集",
    "Viewport changed": "表示を変更",
    "Pending changes": "未適用の変更",
    "Applied": "適用済み",
    "No changes": "変更なし",
    "Auto preview": "自動プレビュー",
    "Preview": "プレビュー",
    "Revert": "元に戻す",
    "Apply": "適用",
    "Discard pending edits (Escape)": "未適用の変更を破棄（Escape）",
    "Apply edits (Ctrl/⌘ Enter)": "変更を適用（Ctrl/⌘ Enter）",
    "Edits preview automatically and apply when you switch options or open Preview.": "変更は自動プレビューされ、オプションの切り替えやプレビューへの移動時に適用されます。",
    "Edits apply when you switch options or open Preview.": "変更はオプションの切り替えやプレビューへの移動時に適用されます。",
    "Auto preview shows these settings after you finish editing a field.": "入力を終えると、自動プレビューで設定を確認できます。",
    "Target changes affect every option. Apply keeps them.": "対象の変更はすべてのオプションに反映されます。「適用」で保存します。",
    "Adjust the view, then Apply to save it in this option.": "視点を調整して「適用」を押すと、このオプションに保存されます。",
    "Apply keeps these playback settings.": "「適用」で再生設定を保存します。",
    "Thumbnail": "サムネイル",
    "Thumbnail updated. Apply saves it; capture again to replace it.": "サムネイルを更新しました。「適用」で保存できます。再取得すると置き換わります。",
    "Apply or revert the pending edits above the option cards before continuing.": "続行する前に、オプションカードの上にある「適用」か「元に戻す」で変更を確定してください。",
    "Camera changed — Apply captures this view": "カメラを変更しました。「適用」でこの視点を保存します",
    "Viewport changed — Apply captures this pose": "表示を変更しました。「適用」でこの姿勢を保存します",
    "Captured — Apply keeps this change": "取得しました。「適用」で変更を保存します",
    "Thumbnail updated — Apply keeps this change": "サムネイルを更新しました。「適用」で保存します",
    "Targets changed — Apply keeps this change": "対象を変更しました。「適用」で保存します",
    "Live preview — Apply keeps these changes": "変更をプレビュー中・「適用」で保存します",
    "Resize hierarchy": "ヒエラルキーの幅を変更",
    "Drag to resize. Double-click to reset. Arrow keys adjust width.": "ドラッグで幅を変更、ダブルクリックでリセット。矢印キーでも調整できます。",
    "Not applied — click an option to preview.": "未適用 — オプションをクリックするとプレビューできます。",
    "Duplicate as variant": "バリエーションを作成",
    "Edit shared material": "共有マテリアルを編集",
    "Material slot": "マテリアルスロット",
    "Material slot for {name}": "{name} のマテリアルスロット",
    "All slots": "すべてのスロット",
    "Unnamed material": "名前のないマテリアル",
    "Slot targeting requires the current web Viewer; older or Unity Viewers may replace all slots.": "スロット指定には最新版の Web Viewer が必要です。旧版や Unity 版では全スロットが置き換わる場合があります。",
    "Material-slot targets require the current web Viewer. Older Viewers and Unity Create may replace the whole renderer.": "マテリアルスロットの指定には最新版の Web Viewer が必要です。旧版の Viewer や Unity Create ではレンダラー全体が置き換わる場合があります。",
    "Live preview on the targeted parts.": "対象パーツに変更をリアルタイムでプレビューします。",
    "Saves an independent material and a new State option. The original is preserved.": "独立したマテリアルと新しいステートオプションを保存します。元のマテリアルは保持されます。",
    "Changes affect every use of this material.": "このマテリアルを使用するすべての箇所に変更が反映されます。",
    "Parts using this material directly are also affected.": "このマテリアルを直接使用するパーツにも反映されます。",
    "Base color / tint": "ベースカラー / 色味",
    "Hex color": "カラーコード",
    "Tint multiplies the existing texture color, including any baked-in decals.": "元のテクスチャの色に指定色を乗算します。テクスチャ内のデカールの色も変わります。",
    "Clearcoat": "クリアコート",
    "Clearcoat roughness": "クリアコートの粗さ",
    "Clearcoat normal": "クリアコートの法線",
    "Normal": "法線",
    "Occlusion": "オクルージョン",
    "Emission": "発光",
    "Preserved texture maps": "保持されるテクスチャ",
    "Textures are shared by variants. Texture replacement is not available here.": "テクスチャはバリエーション間で共有されます。ここではテクスチャの差し替えはできません。",
    "Save variant": "バリエーションを保存",
    "Save material": "マテリアルを保存",
    "New finish": "新しい仕上げ",
    "variant": "バリエーション",
    "Preparing material preview…": "マテリアルのプレビューを準備中…",
    "Material variant saved as a new option": "マテリアルのバリエーションを新しいオプションとして保存しました",
    "Material saved": "マテリアルを保存しました",
    "Choose a material first.": "先にマテリアルを選択してください。",
    "Enter a material name.": "マテリアル名を入力してください。",
    "Unlit materials do not support the paint editor.": "Unlit マテリアルはペイント編集に対応していません。",
    "Add a material target before editing.": "編集する前に対象パーツを追加してください。",
    "Material values must be between 0 and 1, with a valid hex color.": "各値は 0〜1 の範囲にし、有効なカラーコードを入力してください。",
    "Designed for desktop": "パソコン向けの機能です",
    "Model Vista Create is designed for a desktop or laptop with a larger screen and mouse or trackpad. Phones and tablets are not supported yet.": "Model Vista Create は、大きな画面とマウスまたはトラックパッドを備えたパソコン向けに設計されています。スマートフォン・タブレットにはまだ対応していません。",
    "Create workflow": "作成手順",
    "1 Import": "1 読み込み",
    "2 States": "2 ステート",
    "3 Preview": "3 プレビュー",
    "Language": "言語",
    "Viewer ↗": "ビューアー ↗",
    "Export GLB+": "GLB+ を書き出す",
    "Dismiss error": "エラーを閉じる",
    "Continue your draft?": "下書きを再開しますか？",
    "Resume draft": "下書きを再開",
    "Discard": "破棄",
    "· Import notes": "· 読み込みに関する注意",
    "Import another model": "別のモデルを読み込む",
    "Find a part": "パーツを検索",
    "Find a part…": "パーツを検索…",
    "Model parts": "モデルのパーツ",
    "Target of the selected State": "選択したステートの対象",
    "Target": "対象",
    "Frame selection (F)": "選択範囲を表示（F）",
    "Frame selection": "選択範囲を表示",
    "Frame": "表示",
    "State sets": "ステートセット",
    "Filter States by object": "対象オブジェクトでステートを絞り込む",
    "Filter States by type": "種類でステートを絞り込む",
    "All": "すべて",
    "Selected": "選択中",
    "All types": "すべての種類",
    "Select an object to see its States.": "オブジェクトを選択すると、そのステートが表示されます。",
    "No States match these filters.": "条件に一致するステートがありません。",
    "Create State set": "ステートセットを作成",
    "Add your first State set to give this model interactive options.": "＋からステートセットを追加できます。",
    "Interactive model preview. Drag to orbit, scroll to zoom; click a part to select it.": "モデルのプレビュー。ドラッグで回転、スクロールで拡大縮小、クリックでパーツを選択。",
    "Fit model": "全体を表示",
    "Create a GLB+": "GLB+ を作成",
    "Add States to your model, then export.": "モデルにステートを追加して書き出します。",
    "Import GLB / FBX": "GLB / FBX を読み込む",
    "Try a sample model": "サンプルを試す",
    "Files stay on your device.": "ファイルはお使いの端末内で処理されます。",
    "Drop a GLB or FBX (plus its textures) to begin": "GLB または FBX とテクスチャをドロップ",
    "Options": "オプション",
    "+ Capture as new": "＋ 新しいオプションとして保存",
    "Use ＋ next to State sets to begin.": "「ステートセット」の横の＋から始められます。",
    "Model States": "モデルのステート",
    "No visible State sets. Return to States to add one.": "表示するステートセットがありません。「ステート」で追加してください。",
    "Reset to initial options": "初期状態に戻す",
    "Select a State set to edit its options.": "ステートセットを選択すると、オプションを編集できます。",
    "State set name": "ステートセット名",
    "State thumbnail": "ステートのサムネイル",
    "State thumbnail for {name}": "{name} のステートサムネイル",
    "Capture State thumbnail": "ステートのサムネイルを撮影",
    "Replace State thumbnail": "ステートのサムネイルを変更",
    "Capture current view as State thumbnail": "現在の表示をステートのサムネイルとして撮影",
    "Replace State thumbnail with current view": "現在の表示でステートのサムネイルを置き換え",
    "State thumbnail saved to draft": "ステートのサムネイルを下書きに保存しました",
    "Capture option thumbnail": "オプションのサムネイルを撮影",
    "Replace option thumbnail": "オプションのサムネイルを変更",
    "Capture current view as option thumbnail": "現在の表示をオプションのサムネイルとして撮影",
    "Replace option thumbnail with current view": "現在の表示でオプションのサムネイルを置き換え",
    "{name} +{count} more": "{name} ほか {count} 個",
    "No targets": "対象なし",
    "Move State set earlier": "ステートセットを前へ移動",
    "Move State set later": "ステートセットを後へ移動",
    "Duplicate set": "セットを複製",
    "Delete Set": "セットを削除",
    "Show in Viewer": "ビューアーに表示",
    "Option name": "オプション名",
    "Set as Default": "初期状態に設定",
    "Set as Default (use on load)": "初期状態に設定（モデルを開いたときに適用）",
    "Default on load": "モデルを開いたときの初期状態",
    "Move option earlier": "オプションを前へ移動",
    "Move option later": "オプションを後へ移動",
    "State targets": "ステートの対象",
    "Select and frame every target": "すべての対象を選択して表示",
    "Show all": "すべて表示",
    "Help": "ヘルプ",
    "Missing or ambiguous part": "パーツが見つからないか、名前が重複しています",
    "Remove target from this State set": "このステートセットの対象から外す",
    "No targets. Add a part before updating this State.": "対象がありません。更新する前にパーツを追加してください。",
    "Target changes affect every option. Use Update option to save.": "対象の変更はすべてのオプションに適用されます。「オプションを更新」で保存します。",
    "Shader targets": "シェーダーの対象",
    "Material targets": "マテリアルの対象",
    "All Model Vista materials (global shader State).": "すべての Model Vista マテリアル（グローバルシェーダーステート）。",
    "Shader bindings are preserved; edit them in desktop Create.": "シェーダーの割り当ては保持されます。詳細はデスクトップ版 Create で編集してください。",
    "Transform": "移動・回転",
    "Position": "位置",
    "Rotation (degrees)": "回転（度）",
    "Capture current transform": "現在の位置・回転を取得",
    "Current camera": "現在のカメラ",
    "Live": "ライブ",
    "Object properties": "オブジェクトのプロパティ",
    "Local to parent": "親を基準としたローカル値",
    "Select an object to inspect its transform.": "オブジェクトを選択すると位置・回転・スケールを確認できます。",
    "Transform of {name}": "{name} の位置・回転・スケール",
    "Rotation (°)": "回転（°）",
    "{name} position {axis}": "{name} の位置 {axis}",
    "{name} rotation {axis}": "{name} の回転 {axis}",
    "{name} scale {axis}": "{name} のスケール {axis}",
    "Current orthographic projection": "平行投影",
    "Current field of view (degrees)": "現在の画角（度）",
    "Adjust current field of view": "現在の画角を調整",
    "Current orthographic half-height (m)": "現在の平行投影の半高さ（m）",
    "Position (m)": "位置（m）",
    "Rotation (degrees · XYZ)": "回転（度・XYZ）",
    "Camera reference unavailable.": "カメラの基準が見つかりません。",
    "Capture current camera": "現在のカメラを取得",
    "Adjust the view, capture it, then use Update option to save.": "視点を調整して取得し、「オプションを更新」で保存します。",
    "Saved view settings": "保存した視点の設定",
    "Orthographic projection": "平行投影",
    "Field of view (degrees)": "画角（度）",
    "Orthographic half-height (m)": "平行投影の半高さ（m）",
    "These fields edit the option draft. Use Preview changes to view them.": "オプションの下書きを編集します。「変更をプレビュー」で確認できます。",
    "Material choice": "マテリアルの選択",
    "Material": "マテリアル",
    "+ New solid material": "＋ 単色マテリアルを作成",
    "Linked choices": "連動するオプション",
    "Create another State set first, then select the options this preset activates.": "別のステートセットを作成し、このプリセットで適用するオプションを選択してください。",
    "Leave unchanged": "変更しない",
    "Animation playback": "アニメーション再生",
    "Animation clip": "アニメーションクリップ",
    "Stop playback": "再生を停止",
    "This model has no embedded animation clips. Import an animated GLB or FBX, or use Transform States to author motion.": "このモデルにアニメーションクリップはありません。アニメーションを含む GLB / FBX を読み込むか、移動・回転ステートで動きを作成してください。",
    "Playback speed": "再生速度",
    "1 = original speed · 0.5 = half speed · 0 = hold": "1 = 通常速度・0.5 = 半分の速度・0 = 静止",
    "Loop playback": "ループ再生",
    "Plays once and holds the final pose.": "一度再生し、最後のポーズで停止します。",
    "Crossfade (seconds)": "クロスフェード（秒）",
    "Legacy curve clips switch directly; crossfade is available for embedded glTF clips.": "旧形式のカーブは即座に切り替わります。クロスフェードは glTF クリップで利用できます。",
    "Play / restart": "再生 / 最初から",
    "Update option saves playback settings.": "「オプションを更新」で再生設定を保存します。",
    "Stops playback of embedded clips. Animation State sets share the model's clip player.": "クリップの再生を停止します。アニメーションステートセットはモデルの再生機能を共有します。",
    "Transition": "トランジション",
    "Duration (seconds)": "時間（秒）",
    "Easing": "イージング",
    "Linear": "一定速度",
    "EaseIn": "徐々に加速",
    "EaseOut": "徐々に減速",
    "EaseInOut": "加速・減速",
    "Duplicate": "複製",
    "Delete option": "オプションを削除",
    "Preview changes": "変更をプレビュー",
    "Update option": "オプションを更新",
    "Revert changes": "変更を元に戻す",
    "Capture thumbnail": "サムネイルを撮影",
    "Thumbnail updated. Update option saves it; capture again to replace it.": "サムネイルを更新しました。「オプションを更新」で保存できます。撮り直しもできます。",
    "This State record is preserved unchanged.": "このステートのデータは変更せずに保持されます。",
    "Undo": "元に戻す",
    "Redo": "やり直す",
    "Import FBX": "FBX を読み込む",
    "Add separate texture images if needed.": "必要に応じて、別ファイルのテクスチャ画像を追加してください。",
    "Optional · PNG, JPEG, WebP, BMP or TGA": "任意・PNG / JPEG / WebP / BMP / TGA",
    "Clear texture files": "テクスチャの選択を解除",
    "Cancel": "キャンセル",
    "Create a State set": "ステートセットを作成",
    "Type": "種類",
    "Visibility · show or hide parts": "表示・非表示：パーツの表示を切り替える",
    "Transform · move and rotate a part": "移動・回転：パーツを動かす",
    "Camera · save a view": "カメラ：視点を保存する",
    "Material · choose a finish": "マテリアル：見た目を切り替える",
    "Animation · play embedded clips": "アニメーション：内蔵クリップを再生する",
    "Group · combine existing options": "グループ：オプションを組み合わせる",
    "Name": "名前",
    "e.g. Cover, Finish, Inspection": "例：カバー、仕上げ、点検",
    "New solid material": "単色マテリアルを作成",
    "Base color": "ベースカラー",
    "Metallic": "金属度",
    "Roughness": "粗さ",
    "Create material": "マテリアルを作成",
    "File name": "ファイル名",
    "File size": "ファイルサイズ",
    "✓ GLB structure validated and reopened with the shared State runtime.": "✓ GLB の構造とステートの再読み込みを確認しました。",
    "Compatibility notes": "互換性に関する注意",
    "Includes the model, embedded assets, and States. Opening Viewer keeps your draft on this device.": "モデル、内蔵アセット、ステートを含みます。ビューアーを開いても下書きは端末に残ります。",
    "Back": "戻る",
    "Open in Viewer": "ビューアーで開く",
    "Download .glb": ".glb をダウンロード",
    "Capture viewport changes": "表示の変更を取得してください",
    "Unsaved option": "未保存のオプション",
    "Initial option": "初期状態",
    "Select": "選択",
    "Move": "移動",
    "Rotate": "回転",
    "Visibility": "表示・非表示",
    "Camera": "カメラ",
    "Animation": "アニメーション",
    "Group": "グループ",
    "Shader": "シェーダー",
    "Light": "ライト",
    "Unsupported": "未対応",
    "Camera reference": "カメラの基準",
    "Animation root": "再生の基準",
    "Targets": "対象",
    "Model root": "モデルのルート",
    "Drop to assign targets": "ドロップして対象に設定",
    "Drag parts here from the hierarchy": "階層からパーツをここにドラッグ",
    "Use selected part": "選択したパーツを使用",
    "Add selected parts": "選択したパーツを追加",
    "Pause playback": "一時停止",
    "Resume playback": "再生を再開",
    "Change texture files": "テクスチャを変更",
    "Add texture files": "テクスチャを追加",
    "(legacy)": "（旧形式）",
    "{count} selected": "{count} 個を選択",
    "Clip length: {seconds} seconds": "クリップの長さ：{seconds} 秒",
    "Missing clip #{index}": "クリップ #{index} が見つかりません",
    "These {kind} properties are preserved. Use desktop Create for detailed editing.": "{kind} のプロパティは保持されます。詳細はデスクトップ版 Create で編集してください。",
    "Imported {mode} timing is preserved.": "読み込んだ {mode} のタイミングを保持しています。",
    "Show {name} in this option": "このオプションで {name} を表示",
    "Select and frame: {name}": "選択して表示：{name}",
    "Remove target {name}": "対象から {name} を外す",
    "Position {axis}": "位置 {axis}",
    "Rotation {axis}": "回転 {axis}",
    "Current camera position {axis}": "現在のカメラ位置 {axis}",
    "Current camera rotation {axis}": "現在のカメラ回転 {axis}",
    "{count} embedded clip(s). Creates Stop and one option per clip; no part selection needed.": "{count} 個のクリップが内蔵されています。停止と各クリップのオプションを作成します。パーツの選択は不要です。",
    "No embedded animation clips found. Import an animated model or use Transform States to author motion.": "内蔵クリップがありません。アニメーション付きのモデルを読み込むか、移動・回転ステートで動きを作成してください。",
    "Captures the current camera relative to the model.": "モデルを基準として現在のカメラを保存します。",
    "Link options from other State sets after creating this preset.": "作成後、他のステートセットのオプションを組み合わせます。",
    "{count} part(s) selected in the hierarchy.": "階層で {count} 個のパーツを選択しています。",
    "One part, shared by every option. Drop a part to replace it; existing poses are kept.": "全オプションで共有する1つのパーツです。ドロップで対象を置き換えます。保存済みのポーズは保持されます。",
    "Mesh parts, shared by every option. Drop parts to add them.": "全オプションで共有するメッシュです。ドロップして追加できます。",
    "Parts controlled by this State. Check the parts visible in this option. Drop parts to add them.": "このステートで制御するパーツです。表示するパーツにチェックを入れてください。ドロップして追加できます。",
    "Reference space for the saved camera poses. Reference editing requires desktop Create.": "保存したカメラの基準です。基準の編集はデスクトップ版 Create で行ってください。",
    "Clips animate their embedded part bindings. Choose the clip and playback settings below.": "クリップに保存されたパーツの動きを再生します。下の欄でクリップと再生設定を選択してください。",
    "Light targets are preserved; edit them in desktop Create.": "ライトの対象は保持されます。デスクトップ版 Create で編集してください。",
    "Import a model to begin": "モデルを読み込んで開始",
    "Files stay in your browser": "ファイルはブラウザー内で処理されます",
    "Saving draft…": "下書きを保存中…",
    "Draft saved on this device": "下書きを端末に保存しました",
    "Draft could not be saved — export to keep your work": "下書きを保存できませんでした。書き出して作業を保存してください",
    "Local draft storage unavailable — export to keep your work": "下書きの保存先が利用できません。書き出して作業を保存してください",
    "Capture and update the current option, or revert its changes, before continuing.": "続行する前に現在のオプションを取得して更新するか、変更を元に戻してください。",
    "Applying State changes…": "ステートの変更を適用中…",
    "State changes saved to draft": "ステートの変更を下書きに保存しました",
    "Replace this model? Export it first if you want to keep a separate copy of your edits.": "モデルを置き換えますか？編集内容を別に残すには、先に書き出してください。",
    "Opening model…": "モデルを開いています…",
    "This draft version cannot be opened.": "このバージョンの下書きは開けません。",
    "{filename} opened · {count} State sets": "{filename} を開きました・ステートセット {count} 個",
    "Reading model…": "モデルを読み込んでいます…",
    "Reading FBX geometry and textures…": "FBX の形状とテクスチャを読み込んでいます…",
    "Previewing your model's State controls": "ステートをプレビュー中",
    "Authoring States": "ステートを編集中",
    "Restoring initial options…": "初期状態に戻しています…",
    "Initial options restored": "初期状態に戻しました",
    "Select mesh parts for a Material State.": "マテリアルステートにはメッシュのパーツを選択してください。",
    "State set created": "ステートセットを作成しました",
    "Camera changed — capture current camera, then update the option": "カメラを変更しました。現在のカメラを取得してオプションを更新してください",
    "Assign a target before capturing its transform.": "位置・回転を取得する前に対象を設定してください。",
    "Captured — update the option to keep this change": "取得しました。オプションを更新して保存してください",
    "Current appearance captured as a new option": "現在の表示を新しいオプションとして保存しました",
    "Thumbnail preview updated — use Update option to save it": "サムネイルを更新しました。「オプションを更新」で保存してください",
    "Thumbnail could not be captured: {reason}": "サムネイルを撮影できませんでした：{reason}",
    "Targets changed — use Update option to save changes to this State set": "対象を変更しました。「オプションを更新」で保存してください",
    "Target removed from draft — update the option to apply it to the State set": "下書きから対象を外しました。オプションを更新すると適用されます",
    "Drop between parts to reorder, on a part to reparent, or onto Targets to assign": "パーツ間にドロップして順序変更、パーツ上で親を変更、対象リスト上で割り当て",
    "Drop above or below a part to reorder; drop on its center to make it a child. Alt+↑/↓ reorders. Ctrl/⌘ Z undoes.": "パーツの上下にドロップして順序を変更、中央にドロップして子にします。Alt+↑/↓で順序変更、Ctrl/⌘ Zで元に戻します。",
    "Drag cancelled": "ドラッグをキャンセルしました",
    "Hierarchy changes saved to draft": "階層の変更を下書きに保存しました",
    "Insert model": "モデルを挿入",
    "Insert FBX": "FBXを挿入",
    "Insert a model under the selected part": "選択したパーツの下にモデルを挿入",
    "Select one part to insert a model beneath it.": "モデルの挿入先となるパーツを1つ選択してください。",
    "Inserting model…": "モデルを挿入中…",
    "Model inserted — Undo removes it": "モデルを挿入しました。元に戻すと挿入を取り消せます",
    "The model changed. Select a part and try inserting again.": "モデルが変更されました。パーツを選択してから再度挿入してください。",
    "The model's embedded buffer is incomplete.": "モデルの埋め込みバッファが不完全です。",
    "The model contains an unsupported secondary binary buffer.": "モデルに未対応の追加バイナリバッファが含まれています。",
    "The model references a missing embedded buffer.": "モデルが存在しない埋め込みバッファを参照しています。",
    "This model's root extension cannot be combined yet: {extension}": "このモデルのルート拡張はまだ結合できません：{extension}",
    "Selected part actions": "選択したパーツの操作",
    "Expand {name}": "{name} を展開",
    "Collapse {name}": "{name} を折りたたむ",
    "Arrow keys navigate the hierarchy. Home/End selects the first/last visible part.": "矢印キーで階層を移動できます。Home/Endで表示中の最初／最後のパーツを選択します。",
    "Duplicate selected parts": "選択したパーツを複製",
    "Delete selected parts": "選択したパーツを削除",
    "Parts duplicated — Undo restores the previous hierarchy": "パーツを複製しました。元に戻すと以前の階層に戻ります",
    "Parts deleted — Undo restores them": "パーツを削除しました。元に戻すと復元できます",
    "Select parts below the model root first.": "先にモデルルートの下のパーツを選択してください。",
    "These bones are used by a mesh outside the selection. Select that mesh as well before deleting.": "このボーンは選択範囲外のメッシュで使用されています。そのメッシュも選択してから削除してください。",
    "Delete this part's Animation State first before changing its mixed native and legacy animation bindings.": "ネイティブ形式と従来形式が混在するアニメーションの参照を変更するには、先にこのパーツのアニメーションステートを削除してください。",
    "This move would distort the part. Choose a parent with compatible rotation and scale.": "この移動ではパーツが変形します。回転とスケールが適合する親を選んでください。",
    "This move would distort a saved Transform option. Choose a parent with compatible scale.": "この移動では保存済みの移動・回転オプションが変形します。スケールが適合する親を選んでください。",
    "This part has embedded transform animation. Move a parent group instead.": "このパーツには移動・回転・スケールのアニメーションが内蔵されています。親グループを移動してください。",
    "A parent with zero scale cannot receive parts.": "スケールがゼロの親にはパーツを移動できません。",
    "Parts with duplicate hierarchy paths cannot be moved between parents.": "階層パスが重複するパーツは別の親に移動できません。",
    "This move would detach a legacy animation from its target. Move its animation root as well.": "この移動では従来形式のアニメーションが対象から切り離されます。アニメーションのルートも一緒に移動してください。",
    "Material created and assigned to the option": "マテリアルを作成してオプションに割り当てました",
    "Previewing option changes…": "変更をプレビューしています…",
    "Previewing unsaved changes — update or revert this option": "未保存の変更をプレビュー中・オプションを更新するか、元に戻してください",
    "Option updated": "オプションを更新しました",
    "Restoring saved option…": "保存したオプションを復元中…",
    "Saved option restored": "保存したオプションを復元しました",
    "Restoring edit…": "編集内容を復元中…",
    "Edit restored": "編集内容を復元しました",
    "Validating and reopening GLB+…": "GLB+ を検証して再読み込みしています…",
    "GLB validation failed:": "GLB の検証に失敗しました：",
    "{name} did not reopen with all its options. Check its target parts and materials.": "{name} のすべてのオプションを再読み込みできませんでした。対象のパーツとマテリアルを確認してください。",
    "GLB+ validated and reopened successfully": "GLB+ の検証と再読み込みが完了しました",
    "GLB+ download started": "GLB+ のダウンロードを開始しました",
    "Opening in Viewer…": "ビューアーを開いています…",
    "Save the GLB+ download first; local draft storage is unavailable.": "下書きの保存先が利用できません。先に GLB+ をダウンロードしてください。",
    "The model could not be transferred to Viewer: {reason}": "モデルをビューアーに転送できませんでした：{reason}",
    "Viewport changed — capture it into a State option": "表示を変更しました。ステートのオプションとして取得してください",
    "WebGL could not start: {reason}": "WebGL を起動できませんでした：{reason}",
    "Select the parts this visibility State controls.": "表示・非表示ステートの対象パーツを選択してください。",
    "Select one part for this Transform State. Combine multiple transforms with a Group.": "移動・回転ステートには1つのパーツを選択してください。複数の動きはグループで組み合わせられます。",
    "Select the mesh parts this Material State controls.": "マテリアルステートの対象メッシュを選択してください。",
    "Add at least one target before updating this State.": "更新する前に対象を1つ以上追加してください。",
    "Select a part in the hierarchy first.": "先に階層からパーツを選択してください。",
    "Converted {file} to GLB using {parser} · {meshes} meshes · {materials} PBR materials · {clips} animation clips": "{file} を GLB に変換（{parser}）・メッシュ {meshes} 個・PBR マテリアル {materials} 個・アニメーション {clips} 個"
};
